function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.985 13.875c-.345 0-.623.315-.623.703 0 .388.278.703.623.703.343 0 .623-.315.623-.703 0-.388-.28-.703-.623-.703z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.741 20.438l-.997 2.812h.497l1.248-2.344 1.496-1.406 1.495 1.406 1.248 2.344h.498l-.998-2.813-1.246-2.343.25-1.407.996-3.28h.25v-.47h-4.986v.47h.249l.997 3.28.25 1.407-1.247 2.343zm1.744-4.688l-1.246-2.344h3.49l-1.246 2.344h-.998z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.497 13.875H10.5v-1.406h.997v1.406zM12.993 14.344h-.997V12h.997v2.344zM21.469 13.875h-.997V12.47h.997v1.406zM19.973 14.344h-.997V12h.997v2.344z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 1a3 3 0 00-2.959 2.5H11.5A1.5 1.5 0 0010 5H7a2 2 0 00-2 2v22a2 2 0 002 2h18a2 2 0 002-2V7a2 2 0 00-2-2h-3a1.5 1.5 0 00-1.5-1.5h-1.541A3 3 0 0016 1zm1 3a1 1 0 10-2 0 1 1 0 01-1 1h-1.5a.5.5 0 00-.5.5v.4a.1.1 0 00.1.1h7.8a.1.1 0 00.1-.1v-.4a.5.5 0 00-.5-.5H18a1 1 0 01-1-1zm-6 4a1 1 0 01-1-1H7.5a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-21a.5.5 0 00-.5-.5H22a1 1 0 01-1 1H11z",
  fill: "currentColor"
})));